import { bootstrapApplication } from '@angular/platform-browser';
import { clientLogger } from '@core/logging/client-logger';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  clientLogger.error(err),
);
